// extracted by mini-css-extract-plugin
export default {"editButton":"addAllowance_editButton__FSj6-","TableBody":"addAllowance_TableBody__yUmjb","deleteButton":"addAllowance_deleteButton__3jtow"};